import * as React from "react"

interface IconProps {
  color?: string
}

export const RadioButtonActive: React.FunctionComponent<IconProps> = ({ color = "#616161" }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.5" y="1.5" width="21" height="21" rx="10.5" fill="white" stroke={color} strokeWidth="3" />
    <rect x="6.26074" y="6.26099" width="11.4783" height="11.4783" rx="5.73913" fill={color} />
  </svg>
)

export const RadioButtonPassive: React.FunctionComponent<IconProps> = ({ color = "#616161" }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.5" y="1.5" width="21" height="21" rx="10.5" fill="white" stroke={color} strokeWidth="3" />
  </svg>
)
